/**
 * Vue3 плагин для локализации Bitrix
 */
export default {
	install: (app, config = {}) => {
		
		const prefix = config.prefix ? config.prefix : '';
		app.config.globalProperties.$loc = {
			get: (key, replace = null) => window.BX?.Loc?.getMessage(prefix + key, replace),
			
			getPlural: (key, count, replace = null) => window.BX?.Loc?.getMessagePlural(prefix + key, count, replace),
			
			has: (key) => window.BX?.Loc?.hasMessage(prefix + key),
			
			set: (key, value) => window.BX?.Loc?.setMessage(prefix + key, value)
		};
	}
};
